export default class BinaryKind {
	static INTERNAL = 'INTERNAL';
	static EXTERNAL = 'EXTERNAL';
}
